module.exports = __webpack_public_path__ + "img/delete-deactive.219825d3.svg";